import React, {useEffect, useRef, useState} from 'react'
import PropTypes from 'prop-types'
import {Box} from '@salesforce/retail-react-app/app/components/shared/ui'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'

const KlarnaMessage = ({price, locale = 'en-US', variant, page = 'pdp'}) => {
    const containerRef = useRef(null)
    const {
        app: {commerceAPI}
    } = getConfig()

    const {klarna} = commerceAPI || {}
    const {configKlarna} = klarna || {}
    const [scriptLoaded, setScriptLoaded] = useState(false)

    let clientId = null
    let environment = 'playground'
    let scriptURL = null

    // Klarna expects price in cents or the smallest currency unit, so we multiply by 100
    const purchaseAmount = price ? Math.round(price * 100) : 0

    try {
        if (configKlarna) {
            const jsonConfig = JSON.parse(configKlarna)
            clientId = jsonConfig?.clientId
            environment = jsonConfig?.environment || 'playground'
            scriptURL = jsonConfig?.scriptURL
        }
    } catch (e) {
        console.log(e.message)
    }

    useEffect(() => {
        if (!scriptURL || !clientId) return

        let script = document.querySelector(`script[src="${scriptURL}"]`)

        if (!script) {
            script = document.createElement('script')
            script.src = scriptURL
            script.async = true
            script.setAttribute('data-client-id', clientId)
            script.setAttribute('data-environment', environment)

            script.onload = () => setScriptLoaded(true)

            document.body.appendChild(script)
        } else {
            setScriptLoaded(true)
        }
    }, [scriptURL, clientId, environment])

    useEffect(() => {
        if (scriptLoaded && window?.Klarna?.OnsiteMessaging) {
            window.Klarna.OnsiteMessaging.refresh()
        }
    }, [scriptLoaded, purchaseAmount, variant?.productId])

    return (
        clientId &&
        scriptURL && (
            <Box
                ref={containerRef}
                id={`klarna-message-${page}`}
                minHeight="22px"
                sx={{
                    [`#klarna-${page}-bnpl::part(osm-message)`]: {
                        textAlign: 'left',
                        fontSize: '12px',
                        lineHeight: '22px',
                        letterSpacing: '0.065px',
                        fontWeight: '300'
                    },
                    [`#klarna-${page}-bnpl::part(osm-container)`]: {
                        padding: '0',
                        border: 'none',
                        background: 'none'
                    }
                }}
            >
                <klarna-placement
                    id={`klarna-${page}-bnpl`}
                    data-key="credit-promotion-auto-size"
                    data-locale={locale}
                    data-purchase-amount={purchaseAmount}
                ></klarna-placement>
            </Box>
        )
    )
}

KlarnaMessage.propTypes = {
    price: PropTypes.number,
    locale: PropTypes.string,
    variant: PropTypes.shape({
        price: PropTypes.number,
        productId: PropTypes.string
    }),
    page: PropTypes.string
}

export default KlarnaMessage
